import { OPEN_API_TEST, OPEN_API_PRO, BASE_URL } from "@/constants/index";

export function containerBindApi() {
  const apiUrlTest = "/gateway/edi/machine/rebinBoxBind"; //测试环境接口地址
  // const isCn = (localStorage.getItem("lang") || "CN") === "CN";
  return {
    //当前请求URL
    apiBaseUrl: BASE_URL + `${apiUrlTest}`,

    onlineData: {
      // 接口描述
      apiDesc: "apiDocDesc.containerBindapiDesc",
      //接口地址
      testApi: `${OPEN_API_TEST}${apiUrlTest}`,
      proApi: `${OPEN_API_PRO}${apiUrlTest}`,
      infos: [
        [
          {
            key: "apiDocDesc.testUrl",
            value:
              "https://demo-sop.jtfulfillment.cn/gateway/edi/machine/rebinBoxBind"
          },
          {
            key: "apiDocDesc.proUrl",
            value:
              "https://sop.jtfulfillment.cn/gateway/edi/machine/rebinBoxBind"
          },
          { key: "customerid:", value: "CS001" },
          { key: "warehouseCode:", value: "SH.001" },
          { key: "eccompanyid:", value: "STANDARD" },
          {
            key: "KEY:",
            value: "MGY3MTU3M2M3NjYxN2RhNjc3NzM4MzM2Y2Q5ZjQ0ZWU="
          }
        ],
        [
          {
            key: "apiDocDesc.testUrlCn",
            value:
              "https://demo-openapi.jtfulfillment.cn/gateway/edi/machine/rebinBoxBind"
          },
          {
            key: "apiDocDesc.proUrlCn",
            value:
              "https://openapi.jtfulfillment.cn/gateway/edi/machine/rebinBoxBind"
          },
          { key: "customerid:", value: "UPFOS-TEST" },
          { key: "warehouseCode:", value: "SH.001" },
          { key: "eccompanyid:", value: "UPFOS-TEST_PPL" },
          {
            key: "KEY:",
            value: "ZDZmNTM1NWE2ZDQ5NjU4Y2Q4YzY5YWIwZGRjZTEyMzE="
          }
        ]
      ],
      //参数描述  START
      postDataList: [
        //   请求协议参数
        {
          title: "onlineDoc.请求参数",
          value: [
            {
              name: "logistics_interface",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.logisticsInterfaceDesc518"
            },
            {
              name: "data_digest",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.dataDigestDesc519"
            },
            {
              name: "msg_type",
              type: "VARCHAR",
              require: "N",
              normal: "",
              describe: "apiDocDesc.msgTypeDesc520"
            },
            {
              name: "eccompanyid",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.eccompanyidDesc521"
            }
          ]
        },
        //   业务参数
        {
          title: "onlineDoc.业务参数",
          value: [
            {
              name: "warehouseCode",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.warehouseCodeDesc522"
            },
            {
              name: "taskCode",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.taskCodeDesc523"
            },
            {
              name: "orderLines",
              type: "Array",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.orderLinesDesc524",
              children: [
                {
                  name: "basketNo",
                  type: "VARCHAR",
                  require: "C",
                  normal: "",
                  describe: "apiDocDesc.basketNoDesc525"
                },
                {
                  name: "packageCode",
                  type: "VARCHAR",
                  require: "C",
                  normal: "",
                  describe: "apiDocDesc.packageCodeDesc526"
                },
                {
                  name: "boxCode",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.boxCodeDesc527"
                }
              ]
            }
          ]
        }
      ],
      //参数描述  END
      //报文描述 start
      responseDataList: [
        {
          title: "onlineDoc.响应参数",
          value: [
            {
              name: "success",
              type: "BOOLEAN",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.successDesc528"
            },
            {
              name: "reason",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.reasonDesc529"
            },
            {
              name: "successList",
              type: "Array(BoxBindResult)",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.successListDesc530",
              children: [
                {
                  name: "basketNo",
                  type: "VARCHAR",
                  require: "C",
                  normal: "",
                  describe: "apiDocDesc.resultBasketNoDesc531"
                },
                {
                  name: "packageCode",
                  type: "VARCHAR",
                  require: "C",
                  normal: "",
                  describe: "apiDocDesc.resultPackageCodeDesc532"
                },
                {
                  name: "boxCode",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.resultBoxCodeDesc533"
                },
                {
                  name: "shipmentCode",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.resultShipmentCodeDesc534"
                },
                {
                  name: "failReason",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.resultFailReasonDesc535"
                }
              ]
            },
            {
              name: "failList",
              type: "Array(BoxBindResult)",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.failListDesc536",
              children: [
                {
                  name: "basketNo",
                  type: "VARCHAR",
                  require: "C",
                  normal: "",
                  describe: "apiDocDesc.resultBasketNoDesc531"
                },
                {
                  name: "packageCode",
                  type: "VARCHAR",
                  require: "C",
                  normal: "",
                  describe: "apiDocDesc.resultPackageCodeDesc532"
                },
                {
                  name: "boxCode",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.resultBoxCodeDesc533"
                },
                {
                  name: "shipmentCode",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.resultShipmentCodeDesc534"
                },
                {
                  name: "failReason",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.resultFailReasonDesc535"
                }
              ]
            }
          ]
        }
      ],
      //请求示例
      requestCode: {
        warehouseCode: "SH.001",
        taskCode: "TASK001",
        orderLines: [
          {
            basketNo: "B01",
            packageCode: "PKG001",
            boxCode: "BOX001"
          }
        ]
      },
      //返回示例
      responseCodes: [
        {
          title: "onlineDoc.返回成功样例",
          value: {
            logisticproviderid: "YL",
            traceId: "c8410b71661505cdfa7fafb842cf114a",
            responseitems: [
              {
                success: "true",
                reason: "",
                successList: null,
                failList: [
                  {
                    basketNo: "",
                    packageCode: "SO26090200003082-1",
                    boxCode: "RQVin09020001",
                    shipmentCode: "SO26090200003082",
                    failReason: "容器状态非空闲中，不允许绑定"
                  }
                ]
              }
            ]
          }
        },
        {
          title: "onlineDoc.返回失败样例",
          value: {
            traceId: "651e9514fb4dc51901e3403bd687126b",
            responseitems: [
              {
                reason: "任务未找到或已取消",
                errorMsg: "任务未找到或已取消",
                success: "false"
              }
            ],
            logisticproviderid: "YL"
          }
        }
      ]
    }
  };
}
